var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"footer-logo",attrs:{"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }